import type { PageContextServer } from "vike/types";

export function useExamShowcase(pageContext?: PageContextServer) {
  const ctx = pageContext ?? usePageContext();
  return ctx.envs.examMode;
}
